import { Truck } from "lucide-react";
import { useVault } from "@/context/VaultContext";
import { STATUSES } from "@/lib/store";
import { stamp } from "@/lib/util";

const COLUMNS = [...STATUSES, "No status"];

function DeliveryCard({ n, onOpen }) {
  const { folderName } = useVault();
  const r = n.receipt || {};
  return (
    <button type="button" onClick={() => onOpen(n.id)} data-testid={`delivery-card-${n.id}`}
      className="w-full text-left rounded-md border bg-card p-2.5 hover:border-foreground/60 transition-colors">
      <p className="text-sm font-medium truncate">{n.title || `${folderName(n.folderId)} entry`}</p>
      {(r.carrier || r.tracking) && <p className="text-[11px] font-mono text-muted-foreground truncate">{[r.carrier, r.tracking].filter(Boolean).join(" · ")}</p>}
      <p className="text-[10px] font-mono text-muted-foreground mt-1">{stamp(new Date(n.updatedAt || n.createdAt)).slice(0, 16)}</p>
    </button>
  );
}

export function DeliveryBoard({ list, onOpen }) {
  const groups = Object.fromEntries(COLUMNS.map((c) => [c, []]));
  [...list].sort((a, b) => (b.updatedAt || b.createdAt).localeCompare(a.updatedAt || a.createdAt))
    .forEach((n) => groups[STATUSES.includes(n.receipt?.status) ? n.receipt.status : "No status"].push(n));
  const cols = COLUMNS.filter((c) => c !== "No status" || groups[c].length);
  return (
    <div className="rounded-lg border p-4" data-testid="delivery-board">
      <p className="flex items-center gap-2 text-sm font-semibold mb-3"><Truck className="h-4 w-4" />Delivery Board</p>
      <div className="flex gap-3 overflow-x-auto pb-2 snap-x lg:grid lg:grid-cols-4 lg:overflow-visible">
        {cols.map((c) => (
          <div key={c} className="w-52 shrink-0 lg:w-auto snap-start rounded-md bg-muted/50 p-2 space-y-2" data-testid={`delivery-column-${c.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-center justify-between px-1">
              <span className="text-xs font-semibold uppercase tracking-wider">{c}</span>
              <span className="text-xs font-mono text-muted-foreground" data-testid={`delivery-count-${c.toLowerCase().replace(/\s+/g, "-")}`}>{groups[c].length}</span>
            </div>
            {groups[c].map((n) => <DeliveryCard key={n.id} n={n} onOpen={onOpen} />)}
            {!groups[c].length && <p className="px-1 text-[11px] text-muted-foreground">—</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
